import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingBag } from 'lucide-react';
import { useCart } from '../contexts/CartContext';

export const CartIcon = () => {
  const { getCartItemCount } = useCart();
  const itemCount = getCartItemCount();

  return (
    <Link
      to="/panier"
      className="relative inline-flex items-center justify-center w-10 h-10 rounded-full hover:bg-[#F5F0EB] transition-colors"
      aria-label="Panier"
    >
      <ShoppingBag className="text-[#2C1810]" size={24} />
      {itemCount > 0 && (
        <span className="absolute -top-1 -right-1 bg-[#C9A96E] text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">
          {itemCount > 9 ? '9+' : itemCount}
        </span>
      )}
    </Link>
  );
};
